import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  block: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
  },
  refresh: {
    padding: 4,
  },
	ltr: {
		direction: 'ltr',
		unicodeBidi: 'bidi-override',
		textAlign: 'left',
		display: 'flex',
    justifyContent: "flex-end",
		gap: 4,
	},
  text: { whiteSpace: "nowrap" }
});
